// redis.ts

class UpstashRedisClient {
    private baseUrl: string;
    private token: string;

    constructor(url: string, token: string) {
        this.baseUrl = url;
        this.token = token;
    }

    private async request(command: string[]) {
        console.log("[redis]", this.baseUrl, command);
        const response = await fetch(this.baseUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${this.token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(command),
        });

        if (!response.ok) {
            throw new Error(`Redis request failed: ${response.statusText}`);
        }

        const data = await response.json();
        return data.result;
    }

    async mget(...keys: string[]) {
        return this.request(["MGET", ...keys]);
    }
}

export const redis = new UpstashRedisClient(
    import.meta.env.VITE_NODE_ENV === "production"
        ? import.meta.env.VITE_UPSTASH_REDIS_REST_URL!
        : import.meta.env.VITE_DEV_UPSTASH_REDIS_REST_URL!,
    import.meta.env.VITE_NODE_ENV === "production"
        ? import.meta.env.VITE_REDIS_PUBLIC_KEY!
        : import.meta.env.VITE_DEV_REDIS_PUBLIC_KEY!,
);
